import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  LabelContent,
  HeadTableCell,
  RowTableCell,
  CustomTextField,
} from '../../../common';

const EditAdvanceDialog = ({
  open,
  onClose,
  onSave,
  selectedData,
  coeficienteActual,
  dispatch,
  setEditCouponField,
}) => {
  const handleInputAdelantoChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    // Permitir solo números y puntos como entrada válida
    if (/^\d*\.?\d*$/.test(value) || value === '.' || value === '0.') {
      dispatch(
        setEditCouponField({
          key: name,
          value: value,
        })
      );
    }
  };

  const handleDateAdelantoChange = (e) => {
    const value = e.target.value;

    dispatch(setEditCouponField({ key: 'first_due_date', value: value }));
    dispatch(setEditCouponField({ key: 'second_due_date', value: value }));
    dispatch(setEditCouponField({ key: 'third_due_date', value: value }));
  };

  if (!selectedData) return null;

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>Editar Vencimiento</DialogTitle>

      <DialogBody>
        <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <LabelContent label="Contrato" content={selectedData?.orden} labelColor="primary.main" />
          <LabelContent label="Plan" content={selectedData?.plan?.name} labelColor="primary.main" />
          <LabelContent label="Cuota/s" content={selectedData?.cuotas} labelColor="primary.main" />
        </Box>

        <Box
          sx={{
            mt: 3,
            mb: 2,
            fontSize: { xs: '12px', md: '14px' },
            fontWeight: 'bold',
          }}
        >
          <LabelContent
            label="Coeficiente Actual"
            content={coeficienteActual}
            labelColor="primary.main"
          />
        </Box>

        <Table size="small">
          <TableHead>
            <TableRow>
              <HeadTableCell />
              <HeadTableCell />
              <HeadTableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <RowTableCell sx={{ fontWeight: 'bold' }}>Coef.de Punt.:</RowTableCell>
              <RowTableCell>
                <CustomTextField
                  sx={{ mt: 0 }}
                  name="score_coefficent"
                  type="text"
                  size="small"
                  fullWidth
                  value={selectedData.score_coefficent ? selectedData.score_coefficent : ''}
                  onChange={handleInputAdelantoChange}
                />
              </RowTableCell>
              <RowTableCell>
                <CustomTextField
                  sx={{ mt: 0 }}
                  name="first_due_date"
                  type="date"
                  size="small"
                  fullWidth
                  value={
                    selectedData.first_due_date ? selectedData.first_due_date.substr(0, 10) : ''
                  }
                  onChange={handleDateAdelantoChange}
                />
              </RowTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onSave} />
    </DialogContainer>
  );
};

export default EditAdvanceDialog;
